/**
 * Created by Colin.Watson on 3/31/2015.
 */
(function () {
	'use strict';
	angular.module('app.core', [
        // Angular Modules
        'ngRoute',
        'ngCookies',
        // Reusable Modules
        'blocks.router',
        'blocks.logger',
        'blocks.exception',
        'blocks',
        // Third Party Modules
        //'pascalprecht.translate'
	]);
})();
